import React, { Component } from "react";
import { string } from "prop-types";

import I18n from "pages/_components/I18n";
import Button from "pages/_components/Button";

class NoProduct extends Component {
    static propTypes = {
        text: string.isRequired,
        pendingTransactions: string,
    };

    static defaultProps = {
        pendingTransactions: null,
    };

    render() {
        const { text, pendingTransactions } = this.props;

        return (
            <div className="grid-table-data col-start-2 col-span-10">
                <div className="box transparent box-border-dashed flex align-items-center">
                    <Button
                        className="btn-secondary icon-medium btn-only-icon enphasize"
                        image={`images/figma/icon/${pendingTransactions ? "transacciones-pendientes.svg" : "info.svg"}`}
                        block={false}
                    />
                    <span className="data-name">
                        <I18n id={text} />
                    </span>
                </div>
            </div>
        );
    }
}

export default NoProduct;
